module.exports = __webpack_public_path__ + "static/media/6.2.a9b7ee50.png";